module.exports = __webpack_public_path__ + "static/Rosewater4-3153e0cf7fb7e207cf02b5f18497f4f4.png";